<template>
  <div style="background-color:#fff;min-height:500px;border:1px solid #e4e4e4">
    <div style="display:flex;align-items:center;height:150px;margin-bottom:50px;background-color:#F9F9F9;border-bottom:1px solid #e4e4e4">
      <div style="margin-left:76px;text-align:center">
        <div style="margin-bottom:8px">
          <i class="el-icon-info" style="font-size:40px;color:#f90000"></i>
        </div>
        <div style="font-size: 16px;color: #D10217;">
          {{ orderAfterSale.status == "1" ?  '已经提交' : '' }}
          {{ orderAfterSale.status == "2" ?  '重新填写' : '' }}
          {{ orderAfterSale.status == "3" ?  '客服审核通过' : '' }}
          {{ orderAfterSale.status == "4" ?  '已关闭' : '' }}
          {{ orderAfterSale.status == "5" ?  '客户已经邮寄' : '' }}
          {{ orderAfterSale.status == "6" || orderAfterSale.status == "7" ?  '协商退款' : '' }}
          {{ orderAfterSale.status == "8" ?  '已关闭' : '' }}
        </div>
      </div>
      <div style="margin-left:120px;text-align:center">
        <div style="font-size: 16px;color: #999999 ; margin-bottom:8px">订单编号</div>
        <div style="font-size: 14px;color: #666666;">{{ orderAfterSale.orderNo }}</div>
      </div>
      <div style="margin-left:57px;text-align:center">
        <div style="font-size: 16px;color: #999999 ; margin-bottom:8px">申请时间</div>
        <div style="font-size: 14px;color: #666666;">{{  orderAfterSale.createTime }}</div>
      </div>
      <div style="flex:1;display: flex;justify-content: flex-end;margin-right:50px">
        <div
          class="background_style btn"
          :style="{backgroundImage: 'url(' + btn_red + ')' }"
        >
          联系客服
        </div>
      </div>
    </div>
    <div>
      <el-steps :active="orderAfterSale._status - 1 "  align-center class="_steps" :space="200" style="    display: flex;justify-content: center;">
        <el-step title="申请售后" ></el-step>
        <el-step title="客服审核" ></el-step>
        <el-step title="买家退货" ></el-step>
        <el-step title="协商退款" ></el-step>
      </el-steps>
    </div>
    <div
      v-if="orderAfterSale.status <= 4"
      style=";background-color: #F9F9F9;border: 1px solid rgb(228, 228, 228);margin: 20px 40px 34px;min-height:48px;line-height:48px;font-size: 12px;color: #666666;text-indent:20px">
      <div v-if="orderAfterSale.status == 1 " > 已经收到您的售后申请，客服会尽快审核，请耐心等待 </div>
      <div v-else-if="orderAfterSale.status == 2 " >
        <div @click="afterSaleClick(orderAfterSale)" style="cursor : pointer">
          <div>您的售后申请有资料需要更新， <span style="color: #E60012;">去完善>></span> </div>
          <div style="margin-top:20rpx"> {{ orderAfterSale.auditRemark }} </div>
        </div>
      </div>
      <div v-else-if="orderAfterSale.status == 3 " >
        <div  style="margin-botton:10px;display:flex">
          <div style="width:90px;">快递公司 :</div>
           {{ orderAfterSale.expressCompany }}</div>
        <div  style="margin-botton:10px;display:flex;align-items:center">
          <div style="width:90px;">快递单号 :</div>
          <el-input v-model="expressNo" placeholder="请输入快递单号" style="width:300px;display:flex"></el-input>
          <div
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="width:111px;height: 30px;line-height: 30px;margin-left:20px;text-align:center;text-indent:0px;cursor : pointer"
            @click="addExpressCompany"
          >
            提交
          </div>
        </div>
        <div  style="margin-botton:10px;display:flex"><div style="width:90px;">收件人 : </div> {{ name }}</div>
        <div  style="margin-botton:10px;display:flex"><div style="width:90px;">收件电话 : </div>  {{ phone }}</div>
        <div  style="margin-botton:10px;display:flex"><div style="width:90px;">收件地址 : </div>  {{ address }}</div>
      </div>
      <div v-else-if="orderAfterSale.status == 4 " >
        <div>
          <div style="margin-bottom:10px">客服审核未通过。如有疑问，请联系客服。 </div>
          <div> {{ orderAfterSale.auditRemark }} </div>
        </div>
      </div>
    </div>
    <div style="font-size: 16px;color: #999999;margin: 15px 40px ">
      服务单信息
    </div>
    <div style="border : 1px solid #e4e4e4;margin: 20px 40px 34px;">
      <div class="line">
        <div class="name">
          订单编号
        </div>
        <div class="value">{{ orderAfterSale.orderNo}}</div>
      </div>
      <div class="line">
        <div class="name">
          退货原因
        </div>
        <div class="value">{{  orderAfterSale.dictLabel }}</div>
      </div>
      <div class="line">
        <div class="name">
          提交数量
        </div>
        <div class="value">{{ orderAfterSale.quantity }}</div>
      </div>
      <div class="line">
        <div class="name">
          安装时间
        </div>
        <div class="value">{{ orderAfterSale.installationDay }}</div>
      </div>
      <div class="line">
        <div class="name">
          安装后行驶公里
        </div>
        <div class="value">{{ orderAfterSale.mileage }}</div>
      </div>
    </div>

    <div style="font-size: 16px;color: #999999;margin: 15px 40px ">
      问题描述
    </div>
    <div style="border : 1px solid #e4e4e4;margin: 20px 40px 34px;padding:20px;font-size: 14px;color: #666666;min-height:60px">
      {{ orderAfterSale.remark }}
    </div>

    <div style="font-size: 16px;color: #999999;margin: 15px 40px "  >
      审核留言
    </div>
    <div
      style="border : 1px solid #e4e4e4;margin: 20px 40px 34px;padding:20px;font-size: 14px;color: #666666;min-height:60px">
      {{ orderAfterSale.auditRemark }}
    </div>

  </div>
</template>

<script>
import { getDictDataReq } from '@/api/common/index'
import {  orderAfterSaleDetailReq , addExpressCompanyReq } from '@/api/afterSale/index'

export default {
  data() {
    return {
      publicUrl : this.common.publicUrl ,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
      obj : {} ,
      orderAfterSale : {} ,
      options : [] , //退货原因数组
      address : '' ,
      name : '' ,
      phone : '' ,
      expressNo : '' ,
    };
  },

  methods: {
    orderAfterSaleDetail () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      orderAfterSaleDetailReq({
        id : this.obj.id ,
        orderGoodsId : this.obj.orderGoodsId ,
        orderNo : this.obj.orderNo
      }).then( res => {
      loading.close()
       if (res.data.status == 0) {
         if( res.data.orderAfterSale.status != 4 ){
           res.data.orderAfterSale._status = res.data.orderAfterSale.status
         }else {
           res.data.orderAfterSale._status = 2
         }

        this.orderAfterSale = res.data.orderAfterSale
        this.address = res.data.address ? res.data.address : '' ,
        this.name = res.data.name ? res.data.name : '' ,
        this.phone = res.data.phone ? res.data.phone : '' ,
        this.options.forEach( val => {
          if( val.dictValue == this.orderAfterSale.returnType ){
            this.orderAfterSale.dictLabel = val.dictLabel
          }
        })

       }else{
          this.$message({
            message: res.data.statusDesc,
            type: 'warning'
          });
       }
      })
    },
    //添加快递公司
    addExpressCompany(){
      if( this.expressNo.trim() == ''  ){
        this.$message({
          showClose: true,
          message: '请完善信息再提交',
          type: 'warning'
        });
        return
      }
      addExpressCompanyReq({
        id : this.obj.id ,
        orderGoodsId : this.obj.orderGoodsId ,
        orderNo : this.obj.orderNo ,
        // expressCompany : that.data.expressCompany ,
        expressNo : this.expressNo
      }).then( res =>{
        if (res.data.status == 0) {
          this.orderAfterSaleDetail()
        }else{
          this.$message({
            showClose: true,
            message: res.data.statusDesc,
            type: 'warning'
          });
        }
      })
    },
    //点击完善资料
    afterSaleClick(item){
      // console.log( item )
      let obj = {}
      obj.orderNo = item.orderNo
      obj.orderGoodsId = item.orderGoodsId
      obj.quantity = item.quantity
      obj.aftersaleId = item.id

      this.$router.push({
        name: 'ApplyAftersale' ,
        query: {
          params: JSON.stringify( obj )
        }
      })
    },
    //获取选项数据
    getDictData( type ){
      getDictDataReq({
        dictType : type
      }).then( res => {
        if (res.data.status == 0) {
          this.options = res.data.list
          this.orderAfterSaleDetail()
        }
      })
    },
  } ,
  created(){
    this.getDictData( 'returnType' )
    let obj =  JSON.parse( this.$route.query.params )
    this.obj = obj
  } ,
};
</script>

<style scoped lang='stylus'>
._steps >>> .el-step__icon.is-text{
  border-radius: 0;
  background-color: #f90000;
  color: #fff;
  transform: skew(-25deg, 0deg) scale(1.2, 1);;
  width: 30px;
  border:none
}
._steps >>> .el-step__icon-inner{

  transform: skew(20deg, 0deg)
}
.line {
  border-bottom 1px solid #e4e4e4;
  display flex
  height 40px
  line-height 40px ;
  font-size: 14px;
  color: #666666;
  .name {
    width 178px;
    text-align center;
    border-right:1px solid #e4e4e4;
    background-color #f9f9f9
  }
  .value {
    flex: 1;
    text-indent 20px
  }

}
.line:last-child   {
  border-bottom none
}



</style>
